import jobCodeService from '@/api/jobcode.service'

const actions = {
  uploadVid(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .uploadVid(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  uploadWelcomeVid(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .uploadWelcomeVid(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  resetCandidateUploadedVideoAnswers(context) {
    context.commit('resetUploadedVideoAnswers')
  },
  uploadVideoAnswer(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .uploadVideoAnswer(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promises
  },
  getUploadedInterviewAnswers(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .getUploadedInterviewAnswers(context, data)
        .then(response => {
          const answers = response.filter(r => {
            return r.candidateEmail === data.candidateEmail
          })
          context.commit('uploadedVideoAnswers', answers)
          resolve(answers)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  updateVideoTrimming(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .updateVideoTrimming(context, data)
        .then(response => {
          let start = 0
          let end = 0
          for (var pair of data.formData.entries()) {
            if (pair[0] === 'trimStartTime') {
              start = pair[1]
            }
            if (pair[0] === 'trimEndTime') {
              end = pair[1]
            }
          }

          const trimmedInfo = {
            questionNo: data.questionNo,
            start,
            end
          }

          context.commit('trimmedInformation', trimmedInfo)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  uploadProfileVideoAnswer(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .uploadProfileVideoAnswer(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  updateProfileVideoTrimming(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .updateProfileVideoTrimming(context, data)
        .then(response => {
          let start = 0
          let end = 0
          for (var pair of data.formData.entries()) {
            if (pair[0] === 'trimStartTime') {
              start = pair[1]
            }
            if (pair[0] === 'trimEndTime') {
              end = pair[1]
            }
          }

          const trimmedInfo = {
            questionNo: data.questionNo,
            start,
            end
          }

          context.commit('trimmedInformation', trimmedInfo)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  resetTrimmingInfo(context) {
    context.commit('trimmedInformation', null)
  },
  updateJobCode(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .updateJobCode(context, data)
        .then(response => {
          context.commit('updateJobC', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  removeVid(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .removeVid(context, data)
        .then(response => {
          context.commit('videoPercentage', {
            fileIndex: data.quesNo - 1,
            percentCompleted: null
          })
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  deleteWelcomeVid(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .deleteWelcomeVid(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getJobCodeByBookingId(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .getJobCodeByBookingId(context, data)
        .then(response => {
          context.commit('quesBox', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getJobCodeByJobcodeId(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .getJobCodeByJobcodeId(context, data)
        .then(response => {
          const res = response
          // CAUTION: delete below line
          // res[0].questions.push(res[0].questions[0])
          context.commit('jobcode', res)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  findJobCodeByBookingId(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .findJobCodeByBookingId(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },

  createJobCode(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .createJobCode(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  deleteQuesJobCode(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .deleteQuesJobCode(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  publishJobCode(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .publishJobCode(context, data)
        .then(response => {
          context.commit('publishJobC', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },

  applyJob(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .applyJob(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  reusePreviousApplication(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .reusePreviousApplication(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  myAppliedList(context) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .myAppliedList(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  inviteCandidatesToJobCode(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobCodeService
        .inviteCandidatesToJobCode(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  clearVideoQueue(context, data) {
    context.commit('videoPercentage', data)
  },
  clearVideoPercent(context) {
    context.commit('resetVideoPercentage')
  },
  setUploadProgressValue(context, data) {
    context.commit('uploadProgress', data)
  },
  saveInterviewTrackingData(context, data) {
    context.commit('saveInterviewTrackingData', data)
  },
  saveCompanyInfo(context, data) {
    context.commit('saveCompanyInfo', data)
  },
  saveRecruiterInfo(context, data) {
    context.commit('saveRecruiterInfo', data)
  },
  deleteInterviewTrackingData(context, data) {
    context.commit('deleteInterviewData', data)
  },
  showLandScapeScreen(context, data) {
    context.commit('showLandScapeScreen', data)
  },
  showPotraitScreen(context, data) {
    context.commit('showPotraitScreen', data)
  },
  addSkipButton(context, val) {
    context.commit('addSkipButton', val)
  },
  removeSkipButton(context, val) {
    context.commit('removeSkipButton', val)
  }
}

export default actions
